namespace $.$$ {
	$mol_style_define( $shm_knowledge_manual_editor, {
		Input: { flex: { grow: 1 }, minHeight: '20rem' },
		Error: { color: $shm_theme.error },
	} )
}
